export enum FintracFilingStatus {
  DRAFT = 'DRAFT',
  READY_TO_FILE = 'READY_TO_FILE',
  PREFILING_VALIDATION_FAILED = 'PREFILING_VALIDATION_FAILED',
  PREFILING_VALIDATION_SUCCESS = 'PREFILING_VALIDATION_SUCCESS',
  SUBMITTED_WITH_ERRORS = 'SUBMITTED_WITH_ERRORS',
  SUBMITTED_WITH_WARNINGS = 'SUBMITTED_WITH_WARNINGS',
  SUBMITTED_WITH_SUCCESS = 'SUBMITTED_WITH_SUCCESS',
  ARCHIVED = 'ARCHIVED',
}
